import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import {FaCheck} from "react-icons/fa";
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

class FarmaciasEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.enviaRegistro = this.enviaRegistro.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            erroLoadRegistro: "",
            farmacia_id: "",
            titulo_pagina: "",
            loading: false,
            nome: '',
            status: false, 
        };
    }

    componentDidMount() {
        const id = this.props.router.params.id;
    
        if (id) {
            this.setState({
                farmacia_id: id,
                titulo_pagina: 'Editando Farmácia',
                loading: true,
                erroLoadRegistro: ''
            });

            api.get(`/farmacias/${id}/`)
            .then(response => {
                const dados = response.data;

                this.setState({
                    erroLoadRegistro: '',
                    nome: dados.nome,
                    loading: false
                });
            })
                .catch(error => {
                    let erro_msg = 'Erro ao carregar farmácia, tente novamente';
    
                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }
    
                    this.setState({
                        erroLoadRegistro: erro_msg,
                        loading: false
                    });
                });
        } else {
            this.setState({
                farmacia_id: '',
                titulo_pagina: 'Adicionar Farmácia',
                loading: false,
                erroLoadRegistro: '',
            });
        }
    }

    enviaRegistro = (e) => {
        e.preventDefault();

        this.setState({
            loading: true,
            tipoHelper: "",
            cidIdHelper: ""
        });

        //vererifica se é edição ou adição
        const url = (this.state.farmacia_id) ? '/farmacias/'+this.state.farmacia_id+'/' : '/farmacias/'
        const metodo = (this.state.farmacia_id) ? 'put' : 'post'

        let payload = {
            nome: this.state.nome,
        };

        //envia para api
        api({
            method: metodo,
            url: url,
            data: payload,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.farmacia_id) ? 'Farmácia atualizada com sucesso' : 'Farmácia cadastrada com sucesso';

            MySwal.fire({
                title: 'Sucesso!',
                html: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            //redireciona
            if(!this.state.farmacia_id){
                this.props.router.navigate("/farmacias");
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar farmácia, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    handleChange = (event, fieldName) => {
        if(fieldName == 'programa_id') {
            const { value, label } = event;
            this.setState({
                [fieldName]: value,
                programa__nome: label,
            });
        } else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    handleStatusChange = () => {
        this.setState(prevState => ({
            status: !prevState.status,
        }));
    };
    
    render(){
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosFarmacia" id="tabs-farmacias" className="aditus-tabs">
                    <Tab eventKey="dadosFarmacia" title="Dados das Farmácias"> 
                            <Card className="cardDestaque">
                                <Card.Body>                    
                                    <Form onSubmit={this.enviaRegistro}>
                                        <h4>Farmácias</h4>
                                                <Row>
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Nome</Form.Label>
                                                            <Form.Control 
                                                                type="text" 
                                                                name="nome" 
                                                                value={this.state.nome} 
                                                                onChange={e => this.handleChange(e, 'nome')} 
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>                                                
                                                <Row>
                                                    <Col sm={4}>
                                                        <Button variant="success" className="btn-sm" onClick={this.enviaRegistro}>
                                                            <FaCheck className="me-1" /> Salvar Farmácia
                                                        </Button>&nbsp;&nbsp;
                                                    </Col>
                                                </Row>
                                    </Form> 
                                </Card.Body>                
                            </Card>
                    </Tab>
                </Tabs>
            </div>
        )
    }
}

export default withRouter(FarmaciasEdit);